
/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Medical History Component
 * @param response has the backend
 * Medical History component response
 * @param context has settings etc..
 */

export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    let result :any = {
        providerInfo: {},
        error: undefined
    };

    const { log } = context;
    if (response && response.status >= 400) {
        result.error = response;
    }
    if (response?.length > 0) {
        result.providerInfo = response[0];
    }
    log.debug(
        "ccw-gadget,getproviderinfo-athena",
        "getproviderinfo-athena transformation response ", {
        result
    });
    return result;
}